import * as _Ts from './Com_types';
import * as _FTs from './types_firestore';
import * as _STs from './types_storage';

import * as C from '../constants';

export class AppDetails implements _STs.AppDetails {
    version_app?: string;
    platform_app?: string;
    uuid?: string;
    name?: string;
    model?: string;
    platform?: string;
    operating_system?: string;
    os_version?: string;
    manufacturer?: string;
    is_virtual?: boolean;
    mem_used?: number;
    disk_free?: number;
    disk_total?: number;
    real_disk_free?: number;
    real_disk_total?: number;
    web_view_version?: string;
    battery_level?: number;
    is_charging?: boolean;
    language_code?: string;
    language_tag?: string;
}

export class FreakDetails implements _STs.FreakDetails {
    version_firmware?: string;
    version_firmware_os?: string;
}

export class EstimatorDetails implements _STs.EstimatorDetails {
    version_estimator?: string;
    platform_estimator?: string;
    messages?: string[];
}

export class AxeDetails implements _STs.AxeDetails {
    name?: string;
    brand?: string;
    url?: string;
    width_m?: number;
    height_m?: number;
    url_image?: string;
    color?: Color;
    wheel_details?: WheelDetails;
}
export class Color implements _STs.Color {
    r?: number;
    g?: number;
    b?: number;
    a?: number;
}
export class WheelDetails implements _STs.WheelDetails {
    name?: string;
    brand?: string;
    url?: string;
    diameter_m?: number;
    width_m?: number;
    url_image?: string;
    color?: Color;
}
export class BoardDetails implements _STs.BoardDetails {
    name?: string;
    brand?: string;
    url?: string;
    length_m?: number;
    width_m?: number;
    weight_kg?: number;
    tail_length_x_m?: number;
    distance_axe_axe_x_m?: number;
    nose_length_x_m?: number;
    eccentricity_sensor_x_m?: number;
    eccentricity_sensor_y_m?: number;
    eccentricity_sensor_z_m?: number;
    tilt_sensor_x_rad?: number;
    tilt_sensor_y_rad?: number;
    tilt_sensor_z_rad?: number;
    url_image_top?: string;
    url_image_bottom?: string;
    color?: Color;
    axe_details?: AxeDetails;
}
export class BoardSkeleton2D implements _STs.BoardSkeleton2D {
    position?: Vector2D;
    orientation?: Quaternion;
}
export class Vector2D implements _STs.Vector2D {
    x?: number;
    y?: number;

    constructor(x: number, y: number) {
        this.x = x
        this.y = y
    }
}
export class Quaternion implements _STs.Quaternion {
    r?: number;
    i?: number;
    j?: number;
    k?: number;

    constructor(r: number, i: number, j: number, k: number) {
        this.r = r
        this.i = i
        this.j = j
        this.k = k
    }
}
export class BoardSkeleton3D implements _STs.BoardSkeleton3D {
    position?: Vector2D;
    orientation?: Quaternion;
}
/**
 * TODO: Klären, was mit den firebase-analytics geht.
 *
 */
export class Error implements _FTs.Error {
    date_time?: string;
    description: string;

    constructor() {
        this.description = ''
    }
}
export class ErrorReport implements _FTs.ErrorReport {
    id_device?: string;
    errors?: Error[];
}
export class ItemBase64 implements _STs.ItemBase64 {
    name: string;
    b64s: string;

    constructor() {
        this.name = ''
        this.b64s = ''
    }
}
export class ListOfNames implements _STs.ListOfNames {
    label: string;
    names: string[];

    constructor() {
        this.label = ''
        this.names = []
    }
}
export class Location implements _STs.Location {
    name?: string;
    latitude?: number;
    longitude?: number;
    address?: string;
    countryCode?: string;
    countryName?: string;
}
export class Message implements _STs.Message {
    title: string;
    text: string;

    constructor() {
        this.title = ''
        this.text = ''
    }
}
export class Participation implements _STs.Participation {
    id_contest?: string;
    rank?: number;
}
export class Play implements _STs.Play {
    id_device?: string;
    id_record?: string;
    title?: string;
    description?: string;
    location?: Location;
    tmp_degC?: number;
    weather?: string;
    stance?: string;
    discipline?: string;
    steps: PlayStep[];
    freak_details?: FreakDetails;
    app_details?: AppDetails;
    estimator_details?: EstimatorDetails;
    skater_details?: SkaterDetails;
    board_details?: BoardDetails;
    details?: PlayDetails;
    participation?: Participation;
    figures: PlayFigure[];
    sections: PlaySection[];
    nac_record?: unknown;
    nac_derived?: unknown;
    nac_play?: unknown;
    ranking?: _STs.RankingResponse;
    metadata?: _STs.PlayMetadata;

    constructor() {
        this.steps = []
        this.figures = []
        this.sections = []
    }

    static name_split(name: string): [string, string] {
        const id_device = name.slice(0, C.ID_DEVICE_DEFAULT.length)
        const id_record = name.slice(C.ID_DEVICE_DEFAULT.length + 1)
        return [id_device, id_record]
    }

    static name_join(id_device: string, id_record: string): string {
        return id_device + C.INFIX + id_record
    }
}
export class PlayStep implements _STs.PlayStep {
    t_ms?: number;
    q?: Quaternion;
    s_m?: Vector3D;
    v_ms?: Vector3D;
    a_ms2?: Vector3D;
    q_uvw_rst?: Quaternion;
}
export class Vector3D implements _STs.Vector3D {
    x?: number;
    y?: number;
    z?: number;

    constructor(x: number, y: number, z: number) {
        this.x = x
        this.y = y
        this.z = z
    }
}
export class SkaterDetails implements _STs.SkaterDetails {
    name?: string;
    url?: string;
    url_image?: string;
    height_m?: number;
    weight_kg?: number;
}
export class PlayDetails implements _STs.PlayDetails {
    fly_height_m?: number;
    fly_width_m?: number;
    height_difference_m?: number;
    travel_distance_m?: number;
    slide_distance_m?: number;
    air_time_s?: number;
    slide_time_s?: number;
    wheelie_time_s?: number;
    acceleration_uvw_ms2?: Vector3D;
    rotation_speed_max_uvw_rad_s?: Vector3D;
    rotation_count_uvw?: Vector3D;
}
/**
 * Used by the Estimator and by subsequent.
 */
export class PlayFigure implements _STs.PlayFigure {
    i_beg?: number;
    i_end?: number;
    name?: string;
    angle?: number;
    has_backside?: boolean;
    stance?: string;
    difficulty_percent?: string;
    achived?: boolean;
    achieved?: boolean;
    performance_quality_percent?: number;
    details?: PlayDetails; 
    score?: number;
    difficulty_rating?: number;
}
/**
 * Used by the Estimator and by subsequent.
 */
export class PlaySection implements _STs.PlaySection {
    i_beg?: number;
    i_end?: number;
    name?: string;
    stb_pos_u?: boolean;
    stb_pos_v?: boolean;
    stb_pos_w?: boolean;
    stb_pos?: boolean;
    stb_ori_u?: boolean;
    stb_ori_v?: boolean;
    stb_ori_w?: boolean;
    stb_ori?: boolean;
    is_drv?: boolean;
    bumpy?: boolean;
    is_fly?: boolean;
    pitch_kind?: string;
    details?: PlayDetails;
}
export class FigureScore implements _STs.FigureScore {
    figure_index: number;
    figure_name: string;
    figure_name_normalized: string;
    matrix_found: boolean;
    time_range: {
        start: number;
        end: number;
    };
    
    computed_score: number;
    achieved: boolean;
    difficulty_rating?: number;
    performance_quality?: number;
    execution_quality?: number;
    technical_difficulty?: number;

    constructor(
        index: number = 0,
        name: string = '',
        score: number = 0,
        achieved: boolean = false
    ) {
        this.figure_index = index;
        this.figure_name = name;
        this.figure_name_normalized = name.toLowerCase().replace(/\s+/g, '_');
        this.matrix_found = false;
        this.time_range = { start: 0, end: 0 };
        this.computed_score = score;
        this.achieved = achieved;
        this.difficulty_rating = 0;
        this.performance_quality = 0;
        this.execution_quality = 0;
        this.technical_difficulty = 0;
    }
}
export class RankingResponse implements _STs.RankingResponse {
    play_score: {
        total_score: number;
        figures_achieved: number;
        figure_count: number;
    };
    figure_scores?: _STs.FigureScore[];
    version?: string;

    constructor() {
        this.play_score = {
            total_score: 0,
            figures_achieved: 0,
            figure_count: 0
        };
        this.figure_scores = [];
        this.version = '1.0.0';
    }
}
export class PlayMetadata implements _STs.PlayMetadata {
    totalScore: number;
    figuresAchieved: number;
    figureCount: number;
    nationality: string | null;
    location: {
        latitude: number;
        longitude: number;
        address: string;
    } | null;
    userId: string | undefined;
    timestamp: string;

    constructor() {
        this.totalScore = 0;
        this.figuresAchieved = 0;
        this.figureCount = 0;
        this.nationality = null;
        this.location = null;
        this.userId = undefined;
        this.timestamp = new Date().toISOString();
    }
}
export class Record implements _STs.Record {
    id_device?: string;
    id_record?: string;
    title?: string;
    description?: string;
    location?: Location;
    tmp_degC?: number;
    weather?: string;
    stance?: string;
    discipline?: string;
    freak_details?: FreakDetails;
    app_details?: AppDetails;
    samples: RecordSample[];
    participation?: Participation;
    skater_details?: SkaterDetails;
    board_details?: BoardDetails;
    nac_record?: unknown;

    constructor() {
        this.samples = []
    }

    static name_split(name: string): [string, string] {
        const id_device = name.slice(0, C.ID_DEVICE_DEFAULT.length)
        const id_record = name.slice(C.ID_DEVICE_DEFAULT.length + 1)
        return [id_device, id_record]
    }

    static name_join(id_device: string, id_record: string): string {
        return id_device + C.INFIX + id_record
    }
}
export class RecordSample implements _STs.RecordSample {
    t_ms?: number;
    prs_kPa?: number;
    tmp_deg_C?: number;
    q?: Quaternion;
    acc_ms2?: Vector3D;
    omg_rads?: Vector3D;
    mgn?: number;

    static of_bin(RSB: _Ts.RecordSample): RecordSample {
        const RS = new RecordSample()
        RS.t_ms = RSB.t_ms
        RS.prs_kPa = RSB.prs_kPa;
        RS.tmp_deg_C = RSB.tmp_deg_C;
        RS.q = new Quaternion(
            RSB.q_r,
            RSB.q_i,
            RSB.q_j,
            RSB.q_k,
        );
        RS.acc_ms2 = new Vector3D(
            RSB.acc_u_ms2,
            RSB.acc_v_ms2,
            RSB.acc_w_ms2,
        );
        RS.omg_rads = new Vector3D(
            RSB.omg_u_rads,
            RSB.omg_v_rads,
            RSB.omg_w_rads,
        );
        RS.mgn = RSB.mgn;
        return RS
    }
}
export class SkaterSkeleton2D implements _STs.SkaterSkeleton2D {
    pos_abdomen_low?: Vector2D;
    pos_hip_left?: Vector2D;
    pos_hip_right?: Vector2D;
    pos_abdomen_high?: Vector2D;
    pos_knee_left?: Vector2D;
    pos_knee_right?: Vector2D;
    pos_chest_low?: Vector2D;
    pos_ankle_left?: Vector2D;
    pos_ankle_right?: Vector2D;
    pos_chest_high?: Vector2D;
    pos_foot_left?: Vector2D;
    pos_foot_right?: Vector2D;
    pos_neck?: Vector2D;
    pos_shoulder_left_inner?: Vector2D;
    pos_shoulder_right_inner?: Vector2D;
    pos_head?: Vector2D;
    pos_shoulder_left_outer?: Vector2D;
    pos_shoulder_right_outer?: Vector2D;
    pos_elbow_left?: Vector2D;
    pos_elbow_right?: Vector2D;
    pos_wrist_left?: Vector2D;
    pos_wrist_right?: Vector2D;
    pos_hand_left?: Vector2D;
    pos_hand_right?: Vector2D;
}
export class SkaterSkeleton3D implements _STs.SkaterSkeleton3D {
    pos_abdomen_low?: Vector3D;
    pos_hip_left?: Vector3D;
    pos_hip_right?: Vector3D;
    pos_abdomen_high?: Vector3D;
    pos_knee_left?: Vector3D;
    pos_knee_right?: Vector3D;
    pos_chest_low?: Vector3D;
    pos_ankle_left?: Vector3D;
    pos_ankle_right?: Vector3D;
    pos_chest_high?: Vector3D;
    pos_foot_left?: Vector3D;
    pos_foot_right?: Vector3D;
    pos_neck?: Vector3D;
    pos_shoulder_left_inner?: Vector3D;
    pos_shoulder_right_inner?: Vector3D;
    pos_head?: Vector3D;
    pos_shoulder_left_outer?: Vector3D;
    pos_shoulder_right_outer?: Vector3D;
    pos_elbow_left?: Vector3D;
    pos_elbow_right?: Vector3D;
    pos_wrist_left?: Vector3D;
    pos_wrist_right?: Vector3D;
    pos_hand_left?: Vector3D;
    pos_hand_right?: Vector3D;
}
/**
 * TODO: Klären, was mit den firebase-analytics geht.
 *
 */
export class Usage implements _FTs.Usage {
    date_time?: string;
    duration?: number;
    function?: string;
}
export class UsageReport implements _FTs.UsageReport {
    id_device?: string;
    usages: Usage[];

    constructor() {
        this.usages = []
    }
}
export class VideoAnnotation implements _STs.VideoAnnotation {
    id_device?: string;
    id_record?: string;
    details: VideoFrameDetails[];
    labels: VideoAnnotationLabel[];

    constructor() {
        this.details = []
        this.labels = []
    }
}
export class VideoFrameDetails implements _STs.VideoFrameDetails {
    focal_length_m?: number;
    camera_orientation?: Quaternion;
    camera_acceleration?: Vector3D;
    camera_velocity?: Vector3D;
    camera_position?: Vector3D;
    board_skeleton_2d?: BoardSkeleton2D;
    board_skeleton_3d?: BoardSkeleton3D;
    skater_skeleton_2d?: SkaterSkeleton2D;
    skater_skeleton_3d?: SkaterSkeleton3D;
}
export class VideoAnnotationLabel implements _STs.VideoAnnotationLabel {
    i_beg?: number;
    i_end?: number;
    text?: string;
}